import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { ClerkSetup } from "@/auth/ClerkSetup";
import { RequireAuth } from "@/auth/RequireAuth";
import { ErrorBoundary, ToastContainer, TooltipProvider } from "@/components/ui";
import { AppRoutes } from "@/routes/AppRoutes";
import { OnboardingGuard } from "@/routes/OnboardingGuard";
import { Shell } from "@/routes/Shell";
import { queryClient } from "@/services/queryClient";

/**
 * Root composition.
 *
 * Provider stack (outer → inner):
 *   QueryClientProvider → ClerkSetup → BrowserRouter → TooltipProvider
 *   → ErrorBoundary → RequireAuth → OnboardingGuard → Shell → AppRoutes
 */
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ClerkSetup>
        <BrowserRouter>
          <TooltipProvider>
            <ErrorBoundary>
              <RequireAuth>
                <OnboardingGuard>
                  <Shell>
                    <AppRoutes />
                  </Shell>
                </OnboardingGuard>
              </RequireAuth>
            </ErrorBoundary>
          </TooltipProvider>
        </BrowserRouter>
      </ClerkSetup>
      <ToastContainer />
    </QueryClientProvider>
  );
}
